import { useEffect, useState } from 'react';

import type { IView } from '@audacy-clients/core/atoms/wrappers/modules';
import type { IViewContext } from '@audacy-clients/core/utils/viewContext';

import { useGetViewContext } from '~/state/dataEvents';

type TPageLoadCallback = ({
  view,
  viewContext,
}: {
  view?: IView;
  viewContext?: IViewContext;
}) => void;
type TOnPageLoad = (view?: IView) => void;

export const usePageLoad = (
  callbacks: TPageLoadCallback[],
  viewContextManual?: IViewContext,
): TOnPageLoad => {
  const [isPageLoaded, setIsPageLoaded] = useState(false);
  const getViewContext = useGetViewContext();
  const viewId = viewContextManual?.viewId;

  // If the manual viewId changes, assume we need to reset the page load state
  // biome-ignore lint/correctness/useExhaustiveDependencies: Must run on every page load
  useEffect(() => {
    setIsPageLoaded(false);
  }, [viewId]);

  return (view?: IView): void => {
    if (!isPageLoaded) {
      const viewContextDerived = view ? getViewContext(view) : ({} as IViewContext);
      const viewContext = viewContextManual
        ? { ...viewContextDerived, ...viewContextManual }
        : viewContextDerived;
      callbacks.forEach((cb) => cb({ view, viewContext }));
      setIsPageLoaded(true);
    }
  };
};
